import { useState, useEffect } from "react";
import Header from "./components/Header";
import Card from "./components/Card";
import Button from "./components/Button";
import UserMenu from "./components/UserMenu";
import "./Blog.css";

const API = '/api/blog';

export default function Blog({ user, onGoHome, onReadPost, onEditor, onExplore, onLogin, onNewPen, onViewPens, onSettings, onLogout }) {
  const [posts,   setPosts]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState('');

  useEffect(() => {
    fetch(`${API}/get_posts.php?status=published&limit=20`)
      .then(r => r.json())
      .then(data => { setPosts(data.posts || []); setLoading(false); })
      .catch(() => { setError('Failed to load posts. Please try again later.'); setLoading(false); });
  }, []);

  const formatDate = (d) => new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="blog-page">

      {/* NAVBAR */}
      <Header
        onLogoClick={onGoHome}
        navItems={[
          { label: 'Editor',     onClick: onEditor },
          { label: 'Explore',    onClick: onExplore },
          { label: 'Challenges', onClick: () => {} },
          { label: 'Blog',       onClick: () => {} },
        ]}
        rightExtra={
          <span className="blog-nav-link" onClick={onGoHome}>← Back to Home</span>
        }
        authSlot={
          user ? (
            <UserMenu
              user={user}
              onLogout={onLogout}
              items={[
                { label: 'New Pen',  icon: '✏️', onClick: onNewPen },
                { label: 'Home',     icon: '🏠', onClick: onGoHome },
                { label: 'My Pens',  icon: '📁', onClick: onViewPens },
                { label: 'Explore',  icon: '🔥', onClick: onExplore },
                { label: 'Settings', icon: '⚙️', onClick: onSettings },
              ]}
            />
          ) : (
            <Button variant="secondary" size="sm" onClick={onLogin}>Login</Button>
          )
        }
      />

      {/* HEADER */}
      <div className="blog-header">
        <div className="blog-header-badge">📝 WSNCode Blog</div>
        <h1 className="blog-header-title">Tutorials & Articles</h1>
        <p className="blog-header-desc">Learn HTML, CSS, JavaScript and more with our in-depth guides.</p>
      </div>

      {/* POSTS */}
      <div className="blog-container">
        {loading && <div className="blog-loading">Loading posts...</div>}
        {error   && <div className="blog-error">{error}</div>}
       {!loading && !error && posts.length === 0 && (
  <div className="blog-empty">
    <p>No posts yet. Check back soon! 🚀</p>
  </div>
)}
        {!loading && posts.length > 0 && (
          <div className="blog-grid">
            {posts.map(post => (
              <Card hoverable className="blog-card" key={post.id} onClick={() => onReadPost(post.slug)}>
                {post.cover_image && (
                  <div className="blog-card-img">
                    <img src={post.cover_image} alt={post.title} />
                  </div>
                )}
                <div className="blog-card-body">
                  {post.tags && (
                    <div className="blog-card-tags">
                      {post.tags.split(',').map((t, i) => (
                        <span key={i} className="blog-tag">{t.trim()}</span>
                      ))}
                    </div>
                  )}
                  <h2 className="blog-card-title">{post.title}</h2>
                  {post.excerpt && <p className="blog-card-excerpt">{post.excerpt}</p>}
                  <div className="blog-card-meta">
                    <span className="blog-card-date">📅 {formatDate(post.created_at)}</span>
                    <span className="blog-card-views">👁 {post.views} views</span>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>

      {/* FOOTER */}
      <footer className="blog-footer">
        <p>© 2026 WSNCode. All rights reserved.</p>
      </footer>
    </div>
  );
}